"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingFlowStreamlinedExperimentFeatureFlagWithCatch = exports.OnboardingFlowStreamlinedExperimentFeatureFlag = exports.OnboardingState = exports.OnboardingStep = exports.OnboardingFlow = void 0;
const zod_1 = require("zod");
/**
 * An identifier for a specific possible flow (a list of steps in order) for onboarding
 */
exports.OnboardingFlow = zod_1.z.enum(["standard", "streamlined"]);
/**
 * An individual step that can be used in an onboarding flow
 */
exports.OnboardingStep = zod_1.z.enum(["survey", "chooseInvites", "choosePlan", "done"]);
/**
 * Enum representing the state of a user's onboarding flag, stored in their private metadata
 *
 * - incomplete: the user has not completed onboarding
 * - complete: the user has completed onboarding
 * - unknown: we don't know whether the user has completed onboarding, usually because we haven't loaded their private
 *            metadata yet
 *
 * @deprecated We have a new OnboardingDialogStore that should be used to figure out in more detail what to do to
 *             complete onboarding
 */
exports.OnboardingState = zod_1.z.enum(["incomplete", "complete", "unknown"]);
/**
 * Enum of variations for the streamlined onboarding experiment flag in LaunchDarkly
 */
exports.OnboardingFlowStreamlinedExperimentFeatureFlag = zod_1.z.enum(["on", "off", "test", "control"]);
exports.OnboardingFlowStreamlinedExperimentFeatureFlagWithCatch = exports.OnboardingFlowStreamlinedExperimentFeatureFlag.catch(exports.OnboardingFlowStreamlinedExperimentFeatureFlag.enum.off);
//# sourceMappingURL=types.js.map